<template>
  <div class="sidebar mb-4">
    <nav class="navbar navbar-expand-lg navbar-dark">
      <button type="button" class="navbar-toggler m-2" @click="toggleSidebar()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <transition name="expand">
        <div class="navbar-collapse" id="nav" :class="{ 'collapse': !sideBarOpen }">
          <ul class="navbar-nav mr-auto d-flex">
            <li class="nav-item">
              <router-link class="nav-link"
                :to="{ path: '/' }" :exact="true" @click.native="changeNav(999)">
                <i class="fa fa-home"></i>
              </router-link>
            </li>
            <template v-for="(item, id) in navigation(loggedInUser)">
              <li class="nav-item" :key="id">
                <router-link class="nav-link" :to="item.path" @click.native="changeNav(id)">
                  <span class="fa fa-fw" :class="'fa-' + item.icon"></span>
                  <span>{{ item.title }}</span>
                  <span class="badge badge-success" v-if="item.badge > 0">
                    {{ item.badge }}
                  </span>
                </router-link>
              </li>
            </template>
            <li @click="logout" class="nav-item">
              <a class="nav-link">
                <i class="fa fa-fw fa-sign-out-alt"></i> <span>Logout</span>
              </a>
            </li>
          </ul>
          <ul class="navbar-nav pull-right">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/preferences'}">
                <i class="fa fa-fw fa-cog"></i>
                <span class="d-lg-none">Settings</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/notifications'}">
                <i class="fa fa-fw fa-bell"></i>
                <span class="d-lg-none">Notifications</span>
                <span class="badge badge-danger">
                  {{ notificationsCount }}
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </transition>
    </nav>
    <nav class="subnav">
      <ul class="nav navbar-light">
        <template v-for="(subItem, index) in currentSubNav(loggedInUser)">
          <li class="nav-item" :key="index" :class="{ 'last': index === currentSubNav(loggedInUser).length - 1 }">
            <router-link class="nav-link" :to="{ path: subItem.path }" @click.native="changeNav(currentSubKey)">
              <span class="fa fa-fw" :class="'fa-' + subItem.icon"></span>
              <span>{{ subItem.title }}</span>
              <span class="badge badge-success" v-if="subItem.badge > 0">
                {{ subItem.badge }}
              </span>
            </router-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  LOAD_SIDEBAR,
  LOGOUT,
  CHANGE_NAVIGATION,
  TOGGLE_SIDEBAR
} from '@/vuex/types'

export default {
  name: 'SideBar',
  computed: {
    ...mapGetters([
      'navigation',
      'currentSubNav',
      'currentSubKey',
      'notificationsCount',
      'sideBarOpen',
      'loggedInUser'
    ])
  },
  async mounted () {
    await this.$store.dispatch(LOAD_SIDEBAR)
    this.fillNavigation()
  },
  watch: {
    async $route () {
      this.fillNavigation()
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch(LOGOUT)
      this.$router.push('/login')
    },
    fillNavigation () {
      let currentPath = this.$route.path
      let navigation = this.navigation(this.loggedInUser)
      for (let key in navigation) {
        if (currentPath.includes(navigation[key].path)) {
          this.$store.dispatch(CHANGE_NAVIGATION, key)
        }
      }
    },
    changeNav (id) {
      if (id) this.$store.dispatch(CHANGE_NAVIGATION, id)
    },
    ...mapActions({
      toggleSidebar: TOGGLE_SIDEBAR
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/SideBar.vue